import type { JSX, PropsWithChildren } from "react";
import PopupMenu from "@entrilia/shared/components/PopupMenu";
import useResolvedColorSchemeMode from "../../hooks/useResolvedColorSchemeMode";
import { darkTheme, lightTheme } from "../../themes";
import { cornersBeforePositions } from "../common/corners";

interface AccountPopupMenuProps {
  renderElement: JSX.Element;
}

const AccountPopupMenu = ({ renderElement: anchor, children }: PropsWithChildren<AccountPopupMenuProps>) => {
  const resolvedMode = useResolvedColorSchemeMode();
  const popupTheme = resolvedMode === "dark" ? darkTheme : lightTheme;

  return (
    <PopupMenu
      theme={popupTheme}
      anchor={anchor}
      paperProps={(theme) => ({
        width: "17rem",
        overflow: "visible",
        filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
        "&:before": cornersBeforePositions.left("bottom", 20),
        "& .MuiAvatar-root": {
          width: 40,
          height: 40,
          mr: 1,
        },
        marginLeft: theme.spacing(2),
      })}
      anchorOrigin={{
        vertical: "center",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "center",
        horizontal: "left",
      }}
    >
      {children}
    </PopupMenu>
  );
};

export default AccountPopupMenu;
